import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import DeleteLastSeenOptions from '../DeleteLastSeenOptions';

const ModalDeleteLastSeen = ({ data = {}, onSuccess = null, onCancel = null }) => {

    const modalProps = {
        childrenClassName: 'modal-delete-tv-channel'
    };

    return (
        <ModalWrapper {...modalProps}>
            <DeleteLastSeenOptions
                data={data}
                onSuccess={onSuccess}
                onCancel={onCancel}
            />
        </ModalWrapper>
    );
};

export default withOnClose(ModalDeleteLastSeen);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalDeleteLastSeen.jsx